import MaterialRepository from "@/repositories/tuevs/MaterialRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'material',
    namespaced: true,
    state: {
        ...makeState(),
        listAllData: []
    },
    getters: {
        ...makeGetters(),
        allData(state) {
            return state.listAllData
        }
    },
    mutations: {
        ...makeMutations(),
        setAllData(state, array) {
            state.listAllData = array
        }
    },
    actions: {
        async listOne ({ commit, state }, id) {
            commit('setLoading', true)
            await MaterialRepository.fetch(id).then(response => {
                commit('setCurrent', response.data.data.specimen)
            })
            commit('setLoading', false)
        },
        async listAll ({ commit, state }, params) {
            commit('setLoading', true)
            await MaterialRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data)
                commit('setPagination', {
                    ...state.pagination,
                    total: response.data.total
                })
            })
            commit('setLoading', false)
        },
        async search ({ commit, state }, params) {
            commit('setLoading', true)
            await MaterialRepository.fetchAll(params).then(response => {
                if (response.data.data.length > 0){
                    const array = response.data.data
                    commit('setAll', Object.values([...state.list, ...array].reduce((acc,cur)=>Object.assign(acc,{[cur.id]:cur}),{})))
                }
            })
            commit('setLoading', false)
        },
        async findAll({ commit }, params) {
            commit('setLoading', true)
            await MaterialRepository.findAll(params).then(response => {
                commit('setAllData', response.data)
            })
            commit('setLoading', false)
        },
        async listAllItems({ commit }, params) {
            commit('setLoading', true)
            await MaterialRepository.fetchAllItems(params).then(response => {
                commit('setAllData', response.data.data)
            })
            commit('setLoading', false)
        }
    }
}
